import React from 'react'

const EffortMatrixSubcategory: React.FC = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="72" height="72" rx="14.5455" fill="url(#paint0_linear_700_37890)" />
    <path
      d="M26.106 49.1813C28.2911 46.4499 30.4155 43.7792 32.4792 41.1692C33.2076 41.4726 33.8753 41.7761 34.543 41.9582C38.1848 42.8687 41.766 40.3194 42.1302 36.6168C42.4337 33.3998 40.37 30.6077 37.2137 29.94C37.0316 29.8793 36.9102 29.8793 36.9102 29.6366C36.9102 26.3589 36.9102 23.0205 36.9102 19.7428C36.9102 19.6821 36.9102 19.6214 36.9102 19.5C42.4944 19.6821 48.9891 23.324 51.5384 30.4256C54.0877 37.5273 51.5384 45.2966 45.2865 49.6062C39.2167 53.7943 31.3867 53.248 26.106 49.1813Z"
      fill="white"
    />
    <path
      d="M35.0893 19.5C35.0893 19.6214 35.0893 19.7428 35.0893 19.8642C35.0893 23.0812 35.0893 26.2982 35.0893 29.5152C35.0893 29.8186 35.0286 29.8793 34.7251 29.94C33.1469 30.2435 31.933 31.0933 30.9618 32.368C30.9011 32.4287 30.8404 32.5501 30.7797 32.6714C27.5627 31.3968 24.3457 30.0614 21.1895 28.7868C23.496 23.6882 29.0195 19.7428 35.0893 19.5Z"
      fill="white"
    />
    <path
      d="M20.4613 30.4255C23.6783 31.7609 26.8346 33.0962 30.0516 34.3709C29.566 36.3739 29.9909 38.1949 31.2048 39.8337C29.0197 42.5651 26.8953 45.2965 24.7101 48.0279C19.915 43.6577 18.2155 36.4953 20.4613 30.4255ZM24.528 45.2358C24.5887 45.1751 24.6494 45.1751 24.6494 45.1144C26.0455 43.4149 27.4415 41.6547 28.8376 39.8944C28.8983 39.8337 28.8983 39.6516 28.8376 39.5302C28.2306 38.3163 27.9878 37.1023 27.9878 35.767C27.9878 35.5849 27.9271 35.4635 27.745 35.4028C26.4704 34.9172 25.2564 34.3709 23.9818 33.8853C23.1927 33.5818 22.3429 33.2176 21.4931 32.8535C20.7648 37.4058 21.6752 41.5333 24.528 45.2358Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_700_37890"
        x1="35.5325"
        y1="2.5289e-06"
        x2="91.0286"
        y2="43.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6600E8" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
    </defs>
  </svg>
)

export default EffortMatrixSubcategory
